module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all_in",
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "header_all"
  }, [_c('div', {
    staticClass: "header_left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/logo.jpg"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header_right"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": _vm.localeHref('CH')
    }
  }, [_vm._v("中文版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.localeHref('EN')
    }
  }, [_vm._v("ENGLISH")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt15"
  }, [_c('gcse:search')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav_all"
  }, [_c('div', {
    staticClass: "disp_cell"
  }, [_c('ul', {
    staticClass: "drop-down-menu"
  }, _vm._l((_vm.menu), function(itemone, index) {
    return _c('li', {
      key: index
    }, [(!itemone.children[0] && _vm.checkTitle(itemone)) ? _c('a', {
      attrs: {
        "href": _vm.menuHref(itemone),
        "target": _vm.menuTarget(itemone),
        "rel": _vm.menuTarget(itemone) === '_blank' ? 'noopener noreferrer' : null
      }
    }, [_vm._v(_vm._s(_vm.showTitle(itemone)))]) : _vm._e(), _vm._v(" "), (itemone.children[0]) ? _c('a', [_vm._v(_vm._s(_vm.showTitle(itemone)))]) : _vm._e(), _vm._v(" "), (itemone.children[0]) ? _c('ul', {
      staticStyle: {
        "width": "139px"
      }
    }, _vm._l((itemone.children), function(itemtwo, index) {
      return _c('li', {
        key: index
      }, [_c('a', {
        staticStyle: {
          "padding": "0"
        },
        attrs: {
          "href": _vm.menuHref(itemtwo),
          "target": _vm.menuTarget(itemtwo),
          "rel": _vm.menuTarget(itemtwo) === '_blank' ? 'noopener noreferrer' : null
        }
      }, [_vm._v(_vm._s(_vm.showTitle(itemtwo)))])])
    })) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "disp_con"
  }, [_c('div', {
    staticClass: "cell_nav_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cell_nav"
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.menu), function(itemone) {
    return _c('li', [(itemone.children[0]) ? _c('div', {
      staticClass: "title",
      attrs: {
        "var": itemone.id
      },
      on: {
        "click": _vm.subMenu
      }
    }, [_vm._v("\n                " + _vm._s(_vm.showTitle(itemone)) + "\n              ")]) : _c('div', {
      staticClass: "title clicknav",
      on: {
        "click": _vm.subMenu
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.menuHref(itemone),
        "target": _vm.menuTarget(itemone),
        "rel": _vm.menuTarget(itemone) === '_blank' ? 'noopener noreferrer' : null
      }
    }, [_vm._v(_vm._s(_vm.showTitle(itemone)))])]), _vm._v(" "), (itemone.children[0]) ? _c('div', {
      staticClass: "sub clicknav",
      attrs: {
        "var": itemone.id
      }
    }, [_c('ul', _vm._l((itemone.children), function(itemtwo) {
      return _c('li', [_c('a', {
        attrs: {
          "href": _vm.menuHref(itemtwo),
          "target": _vm.menuTarget(itemtwo),
          "rel": _vm.menuTarget(itemtwo) === '_blank' ? 'noopener noreferrer' : null
        }
      }, [_vm._v(_vm._s(_vm.showTitle(itemtwo)))])])
    }))]) : _vm._e()])
  }))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [(_vm.$route.meta.keepAlive) ? _c('div', {
    staticClass: "con_one"
  }, [_c('div', {
    staticClass: "con_one_left"
  }, [(_vm.noticepictures.length > '1') ? _c('div', {
    staticClass: "carousel slide",
    staticStyle: {
      "overflow": "hidden",
      "height": "340px",
      "position": "relative"
    },
    attrs: {
      "id": "carousel-example-generic",
      "data-ride": "carousel"
    }
  }, [_c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._l((_vm.noticepictures), function(notice, index) {
    return (index == '0') ? _c('div', {
      key: notice.id,
      staticClass: "item active"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice, $event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": notice.pictures
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption flex-caption",
      staticStyle: {
        "padding": "10px 20px",
        "text-align": "left",
        "left": "0"
      }
    }, [_vm._v("\n                   " + _vm._s(notice.title) + "\n                ")])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.noticepictures), function(notice, index) {
    return (index > '0' && index < '10') ? _c('div', {
      key: notice.id,
      staticClass: "item"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice, $event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": notice.pictures
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption flex-caption",
      staticStyle: {
        "padding": "10px 20px",
        "text-align": "left",
        "left": "0"
      }
    }, [_vm._v("\n                   " + _vm._s(notice.title) + "\n                ")])])]) : _vm._e()
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : (_vm.noticepictures[0]) ? _c('div', {
    staticStyle: {
      "height": "340px",
      "position": "relative",
      "overflow": "hidden"
    }
  }, [_c('a', {
    attrs: {
      "target": _vm.target(_vm.noticepictures[0]),
      "href": _vm.href(_vm.noticepictures[0])
    },
    on: {
      "click": function($event) {
        _vm.pushToNewsSub(_vm.noticepictures[0], $event)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.noticepictures[0].pictures
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption flex-caption",
    staticStyle: {
      "height": "40px",
      "bottom": "0",
      "padding": "10px 20px",
      "text-align": "left",
      "left": "0"
    }
  }, [_vm._v("\n                   " + _vm._s(_vm.noticepictures[0].title) + "\n                ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "con_one_right"
  }, [_c('div', {
    staticClass: "abgne_tab"
  }, [_c('div', {
    staticClass: "outertab"
  }, [_c('ul', {
    staticClass: "tabs",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.types), function(type, index) {
    return (type.homeDisplay === 1) ? _c('li', {
      key: index,
      class: {
        active: index === 0
      },
      on: {
        "click": function($event) {
          _vm.selectType(type)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(_vm.showType(type)))])]) : _vm._e()
  }))]), _vm._v(" "), _c('HomeNotice', {
    attrs: {
      "type": _vm.type,
      "notices": _vm.notices
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "con_one_left con_tim"
  }, [_c('router-link', {
    staticClass: "hoverimg",
    attrs: {
      "to": {
        name: 'site'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/8.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgwrap"
  }, [_vm._v("場地介紹")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "con_one_right"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "315",
      "src": _vm.video.fileUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'video'
      }
    }
  }, [_c('button', {
    staticClass: "more_btn fright",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("more")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAlive && _vm.course && false) ? _c('div', {
    staticClass: "con_title con_line"
  }, [_c('router-link', {
    staticStyle: {
      "color": "#00907f"
    },
    attrs: {
      "to": {
        name: 'class'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.course.schoolYear) + _vm._s(_vm.academicYear) + _vm._s(_vm.showCourseName()) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con_two"
  }, [(_vm.$route.meta.keepAlive && false) ? _c('div', {
    staticClass: "flexslider"
  }, [_c('ul', {
    staticClass: "slides"
  }, _vm._l((_vm.classes), function(classitem, index) {
    return ((index % 4) == 0) ? _c('li', {
      key: index,
      attrs: {
        "data-thumb": "/../static/images/8.jpg"
      }
    }, [_c('div', {
      staticClass: "bzbox"
    }, [_c('table', [_c('tr', [_c('td', [(_vm.classes[index]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 1]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 1].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 1].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 2]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 2].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 2].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 3]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 3].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 3].id)
        }
      }
    }) : _vm._e()])])])])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_all mt40"
  }, [_c('div', {
    staticClass: "footer_box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "footer_right"
  }, [(_vm.locale == 'CH') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.homeInfoCh)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locale == 'EN') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.homeInfoEn)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_link"
  }, _vm._l((_vm.links), function(link, index) {
    return (link.isActive == 1 && link.trash != 1) ? _c('a', {
      key: index,
      attrs: {
        "target": "_blank",
        "href": _vm.resolveLinkUrl(link.linkUrl)
      }
    }, [_c('img', {
      attrs: {
        "src": link.pictureUrl
      }
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_copy"
  }, [_vm._v("\n      臺灣大學體育室版權所有 Copyright " + _vm._s(_vm.nowYear) + " Department of Athletics, NTU All Rights Reserved\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell_nav_close"
  }, [_c('button', {
    staticClass: "cell_nav_close_btn",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/close.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disp_con"
  }, [_c('a', {
    staticClass: "toggleMenu"
  }, [_c('button', {
    staticClass: "cell_nav_open_btn",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_left"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.422627912698!2d121.53430791500597!3d25.01972768397899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9882cdc64e7%3A0xcfaa4ee05f721105!2z5ZyL56uL6Ie654Gj5aSn5a246auU6IKy5a6k!5e0!3m2!1szh-TW!2stw!4v1515722591657",
      "width": "100%",
      "height": "350",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07564a4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 1179
// module chunks = 4